import styled from 'styled-components';

// this component is needed for when an icon is placed inside the input
const StyledInputWrapper = styled.div`
  position: relative;
`;

export default StyledInputWrapper;
